
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { HistoryList } from '@husky-x/history-list';
import { HistoryMock } from './custom-components-mocks';
import React from 'react'
import StoreLocator from './src/@husky-x/gatsby-theme-husky/components/StoreLocator/StoreLocator';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'HistoryCustomComponent',
        component: () => <HistoryList {...HistoryMock} />,
      },
      {
        key: 'StoreLocator',
        component: StoreLocator,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
